import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'
import Mousetrap from 'mousetrap'

import SearchModal from './search-modal'
import SearchForm from './search-form'
import createStore from './store'

onDomLoad(() => {
  const $dom = $(document)

  const firmSearchBoxes = document.querySelectorAll(
    "[data-behaviour~='quick-search/firm-search-box']"
  )
  const $navButton = $dom.find("[data-behaviour~='quick-search/nav-button']")

  let searchStore

  if (firmSearchBoxes.length || $navButton.length) {
    const currentFirmId = $('#current_firm_id').val()
    const currentCompanyId = $('#current_company_id').val()
    searchStore = createStore({ currentFirmId, currentCompanyId })
  }

  firmSearchBoxes.forEach((node) => {
    const searchFormApp = createApp(SearchForm, {
      isFullHeight: false,
      isInitiallyFocused: true,
      limit: 25,
    })

    searchFormApp.use(searchStore)

    searchFormApp.mount(node)
  })

  const focusOnSearch = function focusOnSearch() {
    if (!firmSearchBoxes.length) {
      searchStore.dispatch('toggleModal')
    }
  }

  Mousetrap.bind('mod+j', () => {
    focusOnSearch()
    return false
  })

  if ($navButton.length) {
    $navButton.on('click', (event) => {
      event.preventDefault()
      focusOnSearch()
    })

    if (!firmSearchBoxes.length) {
      const $searchModalContainer = $dom
        .find("[data-behaviour='quick-search/search-modal']")
        .html('')
      const $div = $('<div>').appendTo($searchModalContainer)

      if ($searchModalContainer.length) {
        const searchModalApp = createApp(
          SearchModal,
          {},
          {
            singletonId: 'global-search-modal',
          }
        )

        searchModalApp.use(searchStore)

        searchModalApp.mount($div.get(0))
      }
    }
  }
})
